import React, { useState, useEffect } from 'react'
import { isAfterHours } from './afterHoursTimeHelper'
import { DateTime } from 'luxon'
import { Box, Text } from '@chakra-ui/react'

export interface Props {
  pollLocalTime?: boolean
  localTime?: DateTime
}

export const TransferCutOff = ({ pollLocalTime = false, localTime }: Props) => {
  const [afterMarketClose, setAfterMarketClose] = useState(isAfterHours(localTime))

  useEffect(() => {
    if (pollLocalTime) {
      // Give users up-to-date information on if the cut-off time has passed
      const interval = setInterval(() => {
        setAfterMarketClose(isAfterHours())
      }, 30000)

      return () => clearInterval(interval)
    }
  }, [pollLocalTime, afterMarketClose])

  return afterMarketClose ? (
    <Box>
      <Text color='red.500'>
        Withdrawals requested after 12:30 PM PT / 3:30 PM ET and Deposits requested after 1:00 PM PT / 4:00 PM ET will
        be processed the next business day.
      </Text>
    </Box>
  ) : null
}
